import * as React from 'react';
//import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Container, Row, Col, Button, Modal, InputGroup, Form, FormControl, Table, ButtonGroup, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaPlusCircle } from "react-icons/fa";
import Swal from 'sweetalert2'
import { useFetch, useAsync } from "react-async"
import { FaRegEdit, FaTimesCircle } from "react-icons/fa";
import Pagination from '@material-ui/lab/Pagination';

import { connect } from "react-redux";
import { ApplicationState } from '../../store';

import * as ApiConfigModels from '../../models/config/ApiConfig'
import * as ApiConfigStore from '../../store/config/ApiConfig'
import * as LoadingStore from '../../store/Loading'
import * as LoadingModels from '../../models/config/Loading'
import * as TestFappStore from '../../store/testConnect/FappConnection'
import * as TestFappModels from '../../models/testConnect/FappConnection'
import { fetchAsync } from '../modules/Common'
type Store = ApiConfigModels.GetApiConfigState & typeof ApiConfigStore.actionCreators | LoadingModels.LoadingState & typeof LoadingStore.actionCreators | TestFappModels.TestFappState & typeof TestFappStore.actionCreators

//const initialTestFapp = async (apiUrl : any) =>
//    fetch(`/v1/test/fapp/connection?apiUrl=`)
//        .then(res => (res.ok ? res : Promise.reject(res)))
//        .then(res => res.json())

const fetchPerson = async ({ id }) => {
    const response = await fetch(`/v1/test/fapp/connection?apiUrl=` + id,)
    if (!response.ok) throw new Error(response.status as any)
    return response.json()
}

class CompanyConfigTable extends React.Component<any, { isready: boolean, userId: any, companyCode: any, checkready: boolean, pageSize: any, pageBtn: any, checkPageSize: boolean }, Store>{

    constructor(props: any) {
        super(props);
        this.state = {
            isready: true,
            userId: '',
            companyCode: '',
            checkready: true,
            pageSize: 25,
            pageBtn: ['', '', ''],
            checkPageSize: true
        }

        this.handleChangePage = this.handleChangePage.bind(this)
        this.handlePageSize = this.handlePageSize.bind(this)
        //this.handleSearch = this.handleSearch.bind(this)
    }

    componentDidMount() {
        const { isready, userId, companyCode } = this.state
        const { checkkey } = this.props

        var appStorage = localStorage.getItem('LG_APPLICATION')
        if (appStorage) {
            var lis = JSON.parse(appStorage)
            console.log(lis)

            if (isready) {
                this.props.requestGetApiConfig(isready, "POST", "", 1, this.state.pageSize)
                this.setState({
                    isready: false,
                    userId: lis.user_id
                })
            }
        }
    }

    componentDidUpdate(nextProps: any, nextState: any) {
        const { checkkey, DeleteAPI, GetAPI } = this.props
        if (checkkey == "Reset" && checkkey != undefined) {
            console.log(checkkey)
            this.handleSearch()
        }

        if (DeleteAPI.isLoadDeleteApiConfig && DeleteAPI.statusDeleteApiConfig == 200) {
            //document.getElementsByClassName('Loader__background')[0].className = "Loader__background hide";
            this.props.UseLoading(false)
            Swal.fire({
                title: 'สำเร็จ',
                text: 'บันทึกข้อมูลสำเร็จ',
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ตกลง',
            }).then((result) => {
                if (result.value) {
                    this.props.requestDeleteApiConfig(true, "CLEAR");
                    this.handleSearch()
                }
            })
        } else if (DeleteAPI.isLoadDeleteApiConfig && (DeleteAPI.statusDeleteApiConfig == 204 || DeleteAPI.statusDeleteApiConfig == 400)) {
            //document.getElementsByClassName('Loader__background')[0].className = "Loader__background hide";
            var msg = JSON.parse(DeleteAPI.messageDeleteApiConfig)
            this.props.UseLoading(false)
            Swal.fire({
                title: 'ไม่สำเร็จ',
                text: msg.message,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ตกลง',
            }).then((result) => {
                if (result.value) {
                    this.props.requestDeleteApiConfig(true, "CLEAR");
                    this.handleSearch()
                }
            })
        }

        if (GetAPI.statusApiConfig == 200 && GetAPI.isLoadApiConfig && this.state.checkPageSize) {
            console.log('change datatable')
            var countingPage: any = 0
            var dataArr: any = []
            countingPage = Math.ceil(GetAPI.responseApiConfig['total_count'] / this.state.pageSize)
            console.log(countingPage)

            for (let i = 0; i < countingPage; i++) {
                var data: any = {}
                data['page'] = i + 1
                //data['pageTab'] = this.props.pageTab
                dataArr.push(data)
            }

            this.setState({
                pageBtn: dataArr,
                checkPageSize: false
            })
        }
    }

    public handleSearch() {
        //document.getElementsByClassName('Loader__background')[0].className = "Loader__background show";
        //this.props.UseLoading(true)
        const { checkkey, job_started_on_from, job_started_on_to } = this.props
        this.props.requestGetApiConfig(true, "POST", "", 1, this.state.pageSize)
        this.props.callbackkey()
        this.setState({
            checkPageSize: true
        })
    }

    handleDelete = (sid: string, api_server_id: string) => {
        //document.getElementsByClassName('Loader__background')[0].className = "Loader__background show";
        Swal.fire({
            title: 'ลบข้อมูล ?',
            text: 'คุณต้องการลบหรือไม่ ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ใช่',
            cancelButtonText: 'ไม่'
        }).then((result) => {
            if (result.value) {
                this.props.UseLoading(true)
                this.props.requestDeleteApiConfig(true, "DELETE", sid, api_server_id);
            }
        })
    }

    handleUpdate = (sid: string, api_server_id: string) => {
        //document.getElementsByClassName('Loader__background')[0].className = "Loader__background show";
        this.props.UseLoading(true)
        this.props.callbackEdit(sid, api_server_id)
        //this.props.requestSearchSftpConfig(true, "GET", sid, companycode, sftp_server_id)
    }

    handlePageSize(e: any) {
        const { isready, pageSize } = this.state
        var parse = parseInt(e.target.value)
        this.setState({
            checkPageSize: true,
            pageSize: parse,
            isready: true
        });
        this.props.requestGetApiConfig(true, "POST", "", 1, pageSize)
    }

    handleChangePage = (event: any, size: any) => {
        const { isready, pageSize } = this.state
        console.log(size);
        this.setState({
            checkPageSize: true,
            isready: true
        })
        this.props.requestGetApiConfig(true, "POST", "", 1, pageSize)
    }

    render() {
        return (
            <React.Fragment>
                <Row className='mt-2'>
                    <Col md={6}>
                        <Container>
                            <Form className="d-flex justify-content-end justify-content-md-start align-items-center text-nowrap" style={{ gap: '0 12px' }}>
                                <Form.Label style={{ margin: 0 }} htmlFor="inlineFormCustomSelectPref">
                                    Show
                                </Form.Label>
                                <Form.Control
                                    as="select"
                                    className="my-1 mr-sm-2"
                                    id="inlineFormCustomSelectPref"
                                    custom
                                    size="sm"
                                    style={{ width: 'fit-content', margin: 0 }}
                                    value={this.state.pageSize}
                                    onChange={this.handlePageSize}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </Form.Control>
                                <Form.Label style={{ margin: 0 }} htmlFor="inlineFormCustomSelectPref">
                                    entries
                                </Form.Label>
                            </Form>
                        </Container>
                    </Col>
                    <Col md={6}>
                        <div className='d-flex justify-content-end my-2 my-lg-0'>
                            <Pagination count={this.state.pageBtn.length > 0 ? this.state.pageBtn.length : undefined} onChange={this.handleChangePage} shape="rounded" defaultPage={1} showFirstButton showLastButton />
                        </div>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col>
                        <Table className="table-bordered table-hover rounded custom-table-list table-responsive-lg" size="sm">
                            <thead className="rounded">
                                <tr style={{ width: '100%' }} className="text-center table-active thead-light require-field">
                                    <th style={{ width: '5%' }} className='text-center'></th>
                                    {/*<th style={{ width: '10%' }}>Company Code</th>*/}
                                    {/*<th style={{ width: '25%' }}>Company Name</th>*/}
                                    <th style={{ width: '30%' }}>API Username</th>
                                    <th style={{ width: '40%' }}>API URL</th>
                                    <th style={{ width: '25%' }}>API ServerID</th>
                                    {/*<th style={{ width: '10%' }}>Status</th>
                                <th style={{ width: '20%' }}>Message</th>*/}
                                </tr>
                            </thead>
                            <tbody>
                                {!this.props.GetAPI.isLoadApiConfig ? <tr><td colSpan={8} style={{ background: "rgba(209, 250, 221, 1)", color: "black", fontSize: '10pt', textAlign: "center" }}><Spinner animation="border" size="sm" />&nbsp;&nbsp;Loading...</td></tr> : <tr></tr>}
                                {this.props.GetAPI.isLoadApiConfig && this.props.GetAPI.statusApiConfig != 200 ? <tr><td colSpan={8} style={{ background: "#b7b7a4", color: "black", fontSize: '10pt', textAlign: "center" }}>&nbsp;&nbsp;No Data...</td></tr> : <tr></tr>}
                                {this.props.GetAPI.statusApiConfig == 200 && this.props.GetAPI.isLoadApiConfig && this.props.GetAPI.responseApiConfig['result_list'] != null && this.props.GetAPI.responseApiConfig['result_list'].map((item: ApiConfigModels.ApiConfig, idx: any) => {
                                    return (
                                        <tr key={idx}>
                                            <td className='text-center'>
                                                <ButtonGroup>
                                                    <Button variant="info" size="sm" onClick={() => this.handleUpdate(item.sid, item.api_serverid)}><FaRegEdit /></Button>
                                                    <Button variant="danger" size="sm" onClick={() => this.handleDelete(item.sid, item.api_serverid)}><FaTimesCircle /></Button>
                                                </ButtonGroup>
                                            </td>
                                            {/*<td className="text-center">{item.companycode}</td>*/}
                                            {/*<td>{item.companyname}</td>*/}
                                            <td>{item.api_url_callfunction}</td>
                                            <td>{item.api_serverid}</td>
                                            <td>{item.api_username}</td>
                                            {/*<td>*/}
                                            {/*{this.props.GetAPI.statusApiConfig == 200 && this.fetchAsync(item.api_url_callfunction)}*/}
                                            {/*{fetchAsync(item.api_url_callfunction)}*/}
                                            {/*</td>*/}
                                            {/*<td>{item.message}</td>*/}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default connect((state: ApplicationState) => ({ ...state.ApiConfig, ...state.Loading, ...state.TestFapp }), ({ ...ApiConfigStore.actionCreators, ...LoadingStore.actionCreators, ...TestFappStore.actionCreators }))(CompanyConfigTable)